
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m9.0244 19.6877c-.37537.3526-.96086.3504-1.33364-.0049l-7.348937-7.0059c-.411817-.3926-.411818-1.0498-.000003-1.4423l7.34894-7.00595c.37278-.35537.95827-.35753 1.33364-.0049.40547.3809.40824 1.02404.00607 1.40842l-5.61636 5.36783h17.58949c.5503 0 .9964.4497.9964 1s-.4461 1-.9964 1h-17.49679l5.52366 5.2792c.40217.3844.3994 1.0276-.00607 1.4085z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    